export default class CollapsableElementGroup {
  constructor(elCollapseTargets, elOtherRelateds) {
    this._timeoutId = 0;

    for(const elRelated of elCollapseTargets.concat(elOtherRelateds)) {
      elRelated.addEventListener('mouseenter', () => {
        elCollapseTargets.forEach(v => v.classList.remove('collapsed'));
        if(this._timeoutId) {
          clearTimeout(this._timeoutId);
          this._timeoutId = 0;
        }
      });
      elRelated.addEventListener('mouseleave', () => {
        this._timeoutId = setTimeout(() => {
          elCollapseTargets.forEach(v => v.classList.add('collapsed'));
          this._timeoutId = 0;
        }, 2000);
      });
    }
  }
}
